import React, { Fragment, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import HelpDeskContent from '../HelpDeskContent';
import HelpDeskCategoryLink, {
  HelpDeskCategoryQuestionT,
} from '../Categories/HelpDeskCategoryQuestion';
import HelpDeskLateral from '../Lateral';
import FooterSimple from '../../FooterSimple';

import { helpDeskTexts } from '../../../utils/generalTexts';
import routes from '../../../utils/routes';
import { regExpAccents, unicode } from '../../../utils/constants';
import { searchOverQuestion } from '../../../utils/textFilter';

type HelpDeskSearchT = {
  categories?: HelpDeskCategory[];
  options?: HelpDeskCategoryQuestionT[];
  searchText?: string;
};

type HelpDeskLateralOptionT = {
  id: string;
  title: string;
  onClick: () => void;
};

const HelpDeskSearch = ({ categories, options, searchText }: HelpDeskSearchT) => {
  const router = useRouter();
  const { search: searchRouter }: any = router.query;

  const restOptions: HelpDeskLateralOptionT[] = [];

  const questionList: HelpDeskCategoryQuestionT[] = [];

  const lateralFirstOption = {
    id: '1',
    title: helpDeskTexts.search.lateral.first(options ? options.length : 0),
    category: '',
    onClick: () => {
      setLinks(options);
      setLateralInfo({
        id: '1',
        title: '',
      });
    },
  };

  const [links, setLinks] = useState<HelpDeskCategoryQuestionT[] | undefined>(options);
  const [lateralInfo, setLateralInfo] = useState({
    id: lateralFirstOption.id,
    title: lateralFirstOption.category,
  });

  const [description, setDescription] = useState<string | undefined>(searchText);

  const filterOptions = (value: any, input: any) => searchOverQuestion(value.title, input);

  categories?.map((data: HelpDeskCategory) => {
    const matchedCategories = data.questions.filter(
      (value: HelpDeskQuestion) =>
        filterOptions(value, searchRouter) &&
        questionList.push({
          id: value.id,
          title: value.title,
          onClick: () => {
            router.push(`${routes.helpDesk}/${data.categoryKeyword}/${value.keyword}`);
          },
        })
    );

    if (matchedCategories.length > 0) {
      restOptions.push({
        id: data._id,
        title: `${data.categoryDescription} (${matchedCategories.length})`,
        onClick: () => {
          setLinks(
            questionList.filter((infoQuestion: any) => infoQuestion.categoryId === data._id)
          );
          setLateralInfo({
            id: data._id,
            title: data.categoryDescription,
          });
        },
      });
    }
  });

  const lateralOptions = !!links?.length ? [lateralFirstOption, ...restOptions] : undefined;

  const breadcrumbPages = [
    {
      label: helpDeskTexts.search.title,
      url: '',
    },
  ];

  useEffect(() => {
    const newDescription =
      links?.length === options?.length
        ? searchText
        : helpDeskTexts.search.isDataSpecific(
            links?.length || 0,
            String(searchRouter.normalize(unicode).replace(regExpAccents, '').toLowerCase()),
            lateralInfo.title
          );

    setDescription(newDescription);
  }, [links]);

  useEffect(() => {
    setLinks(options);
  }, [options]);

  return (
    <Fragment>
      <HelpDeskContent
        categories={categories}
        breadcrumbPages={breadcrumbPages}
        title={helpDeskTexts.search.title}
        description={description}
        content={
          links &&
          links.map((option: HelpDeskCategoryQuestionT, index: number) => (
            <HelpDeskCategoryLink
              key={`help_desk_question_${index}`}
              title={option.title}
              onClick={option.onClick}
            />
          ))
        }
        lateral={
          lateralOptions && (
            <HelpDeskLateral
              title={helpDeskTexts.search.lateral.title}
              selectedId={lateralInfo.id}
              options={lateralOptions}
            />
          )
        }
      />

      <FooterSimple />
    </Fragment>
  );
};

export default HelpDeskSearch;
